import React, { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

// Com thousandSeparator='.' (convencao BR), o NumericFormat v5 precisa saber
// que o `value` recebido eh um "numeric string" cru (ex: "19000") e nao uma
// string ja formatada (ex: "19.000,00"). Sem `valueIsNumericString`, a lib
// auto-detecta com base no tipo: ok para number, mas se o valor chegar como
// string (Sequelize DECIMAL, react-hook-form em algum fluxo, etc), a
// heuristica de parse confunde o "." de milhar com decimal e exibe valor
// errado (ex: 19000 -> "R$ 19,00"). Coercao explicita resolve.
const CurrencyTextField = forwardRef(({ onChange, value, ...other }, ref) => (
  <NumericFormat
    {...other}
    value={value === '' || value === null || value === undefined ? '' : String(value)}
    valueIsNumericString
    getInputRef={ref}
    onValueChange={(values) => {
      onChange(values.floatValue);
    }}
    thousandSeparator={'.'}
    decimalSeparator={','}
    decimalScale={2}
    fixedDecimalScale={true}
    prefix="R$ "
  />
));

export default CurrencyTextField;
